import {
  defaultTheme,
  SapphireProvider,
  Flex,
  View,
  tokens,
  Typography,
  Link,
} from "@sapphire-react/core";
import { BaseLayout, FormLayout, ResultLayout } from "./components";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { useSapphireMedia } from "./hooks";
import { useLoanInsuranceForm } from "./hooks/useLoanInsuranceForm";
import { colors } from "./styles";
import { ResetSitecoreStyles } from "./utils";

export function App() {
  const form = useLoanInsuranceForm();
  const { allFields, isValid } = form;
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const isMobile = isExtraSmall || isSmall;

  return (
    <ResetSitecoreStyles>
      <SapphireProvider
        theme={defaultTheme}
        locale={"sv-SE"}
        width={"100%"}
        overlayZIndex={1000}
      >
        <Flex
          UNSAFE_style={{ boxSizing: "border-box" }}
          marginTop={tokens.size.spacing6xl}
          width={"100%"}
          justifyContent={"center"}
        >
          <View
            width={"100%"}
            marginTop={tokens.size.spacingXs}
            marginBottom={tokens.size.spacingXl}
            maxWidth={{ base: 444, sm: 968 }}
            alignItems={"center"}
            UNSAFE_style={{ textAlign: "center" }}
            borderRadius={{
              base: tokens.size.radiusMd.value,
              sm: tokens.size.radiusSm.value,
            }}
          >
            <Typography.Heading level={3} data-test-id={"calculator-heading"}>
              Beräkna premien för ditt låneskydd
            </Typography.Heading>

            <Typography.Body size={"lg"} data-test-id={"calculator-suheading"}>
              Som medlem i ett TCO-anslutet fackförbund kan du ta del av en
              färdigförhandlad rabatt på Låneskydd hos Danske Bank. Välj ditt
              förbund och läs mer på{" "}
              <Link>
                <a
                  href={"http://danskebank.se/tco"}
                  target={"_blank"}
                  rel={"noreferrer"}
                >
                  danskebank.se/tco
                </a>
              </Link>
              .
            </Typography.Body>
          </View>
        </Flex>
        <BaseLayout border={"none"} maxWidth={974}>
          <Flex justifyContent={"center"} width={"100%"}>
            <View minWidth={{ base: "100%", sm: 336, md: 486 }} width={"100%"}>
              <FormLayout>
                <Form form={form} />
              </FormLayout>
            </View>
          </Flex>
          {isMobile && (
            <View
              height={1}
              width={"100%"}
              backgroundColor={tokens.color.borderSecondary.value}
            />
          )}

          <Flex justifyContent={"center"} width={"100%"}>
            <View
              minWidth={{ base: "100%", sm: 336, md: 486 }}
              position={"relative"}
              backgroundColor={colors.sand50}
              width={"100%"}
              borderBottomRightRadius={tokens.size.borderMd}
              borderTopRightRadius={tokens.size.borderMd}
            >
              <ResultLayout withSeparator={!isMobile}>
                <Results data={allFields} isValid={isValid} />
              </ResultLayout>
            </View>
          </Flex>
        </BaseLayout>
      </SapphireProvider>
    </ResetSitecoreStyles>
  );
}
